<template>
  <v-form class="registerForm" v-model="valid" ref="form" style="height: 100vh;">
    <!-- Add language selector at the top-right corner -->
    <div class="language-selector-container white-text">
      <LanguageSelector isRegisterFlow />
    </div>
    
    <v-container class="login-container" fluid>
      <v-row style="height: 100% !important;">
        <v-col class="pa-12 d-flex align-center" cols="6">
          <v-container class="ml-12" fluid>
            <v-row>
              <v-col cols="12">
                <h1>{{$t('joinSmartTraders')}}<span style="color: #28EA96 !important; font-family: 'Aeonik' !important; font-weight: bold; font-size: inherit !important;">{{$t('smartTraders')}}</span></h1>
                <p class="mb-3"> {{ $t('createSwisetAccount') }}</p>
              </v-col>
              <v-col v-if="step === 1" cols="7">
                  <v-text-field v-model="firstName" :label="$t('form.firstName.label')" :rules="firstNameRule" outlined/>
                  <v-text-field v-model="lastName" :label="$t('form.lastName.label')" :rules="lastNameRule" outlined/>
                  <v-text-field v-model="email" :label="$t('form.email.label')" :rules="emailRule" type="email" outlined/>
              </v-col>
              <v-col v-else-if="step === 2" cols="7">
                  <v-text-field v-model="username" :label="$t('form.username.label')" :rules="usernameRule" outlined/>
                  <v-text-field v-model="password" :label="$t('form.password.label1')"
                                :rules="passwordRule" :type="showPassword ? 'text' : 'password'" outlined>
                    <v-icon style="font-size: 16px;" slot="append" class="icon"  @click="showPassword = !showPassword">
                      {{ (showPassword) ? 'fa-eye' : 'fa-eye-slash' }}
                    </v-icon>
                  </v-text-field>
                  <v-text-field v-if="password !== ''" v-model="confirmPassword" :label="$t('form.password.label2')"
                                :rules="confirmPasswordRule" :type="showConfirmPassword ? 'text' : 'password'" outlined>
                    <v-icon style="font-size: 16px;" slot="append" class="icon" @click="showConfirmPassword = !showConfirmPassword">
                      {{ (showConfirmPassword) ? 'fa-eye' : 'fa-eye-slash' }}
                    </v-icon>
                  </v-text-field>
              </v-col>
              <v-col v-else-if="step === 3" cols="7">
                  <v-autocomplete v-model="country" :items="countries" item-text="name" item-value="name" 
                                :label="$t('form.country.label')" :rules="countryRule" outlined/>
                  <v-select color="white" v-model="traderExperience" :items="experiences" item-text="text" item-value="value"
                           :label="$t('form.experience.label')" :rules="experienceRule" outlined/>
                  <v-select color="white" v-model="traderType" :items="traderTypes" item-text="text" item-value="value"
                           :label="$t('form.traderType.label')" :rules="traderTypeRule" outlined/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div v-if="step === 2 || step === 3" class="d-flex align-center justify-start">
                  <v-btn class="mr-3 secondary" @click="goBack">{{ $t('backBtn') }}</v-btn>
                  <v-btn v-if="step === 2" :disabled="!valid"  @click="goNext">{{ $t('nextBtn') }}</v-btn>
                  <v-btn v-if="step === 3" :disabled="!valid" :loading="loadingRegister"
                         @click="createAccount">{{ $t('createBtn') }}</v-btn>
                </div>
                <v-btn v-else :disabled="!valid" @click="validateEmail">{{ $t('nextBtn') }}</v-btn>
                <p class="mt-12 label" v-html="$t('alreadyHaveSwisetAccount')"/>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col class="signup-image" cols="6">
          <!--transition name="fade" style="padding: 0; margin: 0;">
            <v-img :src="bigImageSrc" :key="bigImageSrc" data-toggle="tooltip" data-placement="bottom" title="goTop" alt="" contain max-height="100vh"/>
          </transition!-->
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog for existing email !-->
    <v-dialog v-model="existingUsernameOrEmail" max-width="500">
      <v-card outlined>
        <v-card-title class="py-5 headline grey lighten-2 justify-center">
          <h3 v-if="existingEmail">{{ $t('existsInSwiset', {data: email}) }}</h3>
          <h3 v-if="existingUsername">{{ $t('existsInSwiset', {data: username}) }}</h3>
        </v-card-title>
        <v-card-text class="my-5 text-center justify-center">
          <p v-if="existingEmail" v-html="$t('resetPassword')"></p>
          <p v-if="existingUsername">{{ $t('anotherUsername') }}</p>
          <v-btn @click="existingUsernameOrEmail = false"> Ok</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog for referred register!-->
    <v-dialog v-model="from_referred_dialog" max-width="500">
      <v-card outlined>
        <v-card-title class="py-5 headline grey lighten-2 justify-center">
          <h3 >{{referred_dialog_title}}</h3>
        </v-card-title>
        <v-card-text class="my-5 text-center justify-center">
          <p>{{ referred_dialog_text }}</p>

          <v-btn @click="from_referred_dialog = false"> Ok</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import ReferalProgramRepository from '../../../repositories/referalProgram';
import AuthRepository from '../../../repositories/auth';
import PostAfiliatesUtilites from '../../../services/referalProgramUtiliities';
import countries from '../countries';
import LanguageSelector from '../../../components/LanguageSelector.vue';
import { getRecaptchaToken } from '../../../services/recaptcha';

export default {
  props: {
    referred: String
  },
  name: "Welcome",
  components: {
    LanguageSelector
  },
  data() {
    return {
      bigImageSrc: 'https://hub.swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png',
      images: [
        { src: 'https://hub.swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png', },
        { src: 'https://hub.swiset.com/wp-content/uploads/2020/05/Automatic-Trading-Journal-in-Swiset.png', },
      ],

      step: 1,
      existingUsernameOrEmail: false,
      existingUsername: false,
      existingEmail: false,
      valid: false,
      validSecond: false,
      loadingRegister: false,
      showPassword: false,
      showConfirmPassword: false,

      highlight: '',
      landingKey: '',
      discount: 0,

      from_referred : false,
      from_referred_dialog:false,

      // Invite code from URL
      inviteCode: null,
      //data
      referred_dialog_title:"",
      referred_dialog_text:"",
      referrer_id: "",
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      password: '',
      confirmPassword: '',
      firstNameRule: [
        p => !!p || this.$t('form.firstName.rule'),
      ],
      lastNameRule: [
        p => !!p || this.$t('form.lastName.rule'),
      ],
      emailRule: [
        e => !!e || this.$t('form.email.rule'),
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || this.$t('form.email.rule2'),
      ],
      usernameRule: [
        u => !!u || this.$t('form.username.rule1'),
        u => (u || '').length < 35 || this.$t('form.username.rule2'),
        u => !u.includes('@') || this.$t('form.username.rule3'),
        u => !u.includes('&') || this.$t('form.username.rule4'),
        u => (u.split(' ').length <= 1) || this.$t('form.username.rule5'),
      ],
      passwordRule: [
        p => !!p || this.$t('form.password.rule1'),
        p => (p || '').length < 60 || this.$t('form.password.rule2'),
        p => (p || '').length > 6 || this.$t('form.password.rule3'),
      ],
      confirmPasswordRule: [
        p => !!p || this.$t('form.password.rule1'),
        p => p === this.password || this.$t('form.password.rule4'),
      ],

      // New data properties
      country: '',
      traderExperience: '',
      traderType: '',
      countries: countries,
      experiences: [
        { text: this.$t('experiences.learning'), value: 'LEARNING' },
        { text: this.$t('experiences.demo'), value: 'TRADING_DEMO' },
        { text: this.$t('experiences.realNoProfit'), value: 'TRADING_REAL_WITHOUT_PROFIT' },
        { text: this.$t('experiences.profitSixMonths'), value: 'PROFIT_LESS_6_MONTHS' },
        { text: this.$t('experiences.profitConsistent'), value: 'PROFIT_MORE_6_MONTHS' },
      ],
      traderTypes: [
        { text: 'Swing Trader', value: 'Swing Trader'},
        { text: 'Day Trader', value: 'Day Trader' },
        { text: 'Core Trader', value: 'Core Trader'},
        { text: this.$t('traderTypes.highFrequencyTrader'), value: 'High-Frecuency Trader'},
        { text: this.$t('traderTypes.iDontKnow'), value: 'I don\'t know'},
      ],

      // New validation rules
      countryRule: [
        c => !!c || this.$t('form.country.rule'),
      ],
      experienceRule: [
        e => !!e || this.$t('form.experience.rule'),
      ],
      traderTypeRule: [
        t => !!t || this.$t('form.traderType.rule'),
      ],
    };
  },
  computed: {
    _seconds: () => 1000,
  },
  created() {
    // Set dark mode for Welcome view
    setTimeout(() => {
      this.$vuetify.theme.dark = true;
    }, 100);
    this.getQueryParams();
    // Check for inviteCode in URL query params
    if (this.$route.query.inviteCode) {
      this.inviteCode = this.$route.query.inviteCode;
      console.log('Invite code detected in register:', this.inviteCode);
    }
  },
  beforeDestroy() {
    // Reset theme to previous state when leaving view
  },
  mounted() {
    this.referrer_id=this.referred
    if(this.$store.state.whitelabel.partner !== null ){
      this.referrer_id = this.$store.state.whitelabel.partner.shortName;
    }
    if(this.referrer_id==undefined && this.$route.hash){
      this.referrer_id=this.$route.hash.split("#a_aid=")[1] 
    }
    if(this.referrer_id!=undefined){
      this.from_referred = true;
      const postAfiliateCampaingId = this.$store.state.whitelabel.partner !== null ? process.env.VUE_APP_POSTAFFILIATE_WL_CAMPAIGN_ID:process.env.VUE_APP_POSTAFFILIATE_CAMPAIGN_ID;
      const postAfiliateBannerId = this.$store.state.whitelabel.partner !== null ? process.env.VUE_APP_POSTAFFILIATE_WL_BANNER_ID:process.env.VUE_APP_POSTAFFILIATE_BANNER_ID;
      const referrerExists = this.checkReferrer(this.referrer_id);
      if(referrerExists){
        PostAfiliatesUtilites.clickTracking(this.referrer_id,postAfiliateCampaingId,postAfiliateBannerId);
      }
    }
    this.setTimerImage();
  },
  methods: {
    goNext() {
      this.step++;
      this.$refs.form.resetValidation();
    },
    goBack() {
      this.step--;
    },
    async checkReferrer(referrer){
        await ReferalProgramRepository.getReferrer(referrer).then((response) => {
            if(response.status < 400) {
                if (response.data == false) {
                    this.referred_dialog_title = this.$t('noReferrerTitle');
                    this.referred_dialog_text = this.$t('noReferrerText', {data: this.referrer_id})
                } else {
                    this.referred_dialog_title = this.$t('referredRegisterTitle');
                    this.referred_dialog_text = this.$t('referredRegisterText', {data: this.referrer_id})
                }
                if(!(this.$store.state.whitelabel.partner !== null)){
                  this.from_referred_dialog = true;
                }
                return response.data;
            }else{
              return false;
            }
        });
    },  
    setTimerImage() {
      let endTime = new Date();
      endTime.setSeconds(endTime.getSeconds() + 8);
      const timer = setInterval(() => {
        let now = new Date();
        let distance = endTime.getTime() - now.getTime();
        if(distance < 1) {
          this.setImage();
          clearInterval(timer);
          this.setTimerImage();
        }
      }, 1000);
    },
    setImage() {
      let currentImageIndex = this.images.findIndex((img) => img.src === this.bigImageSrc);
      currentImageIndex++;
      this.bigImageSrc = this.images[(currentImageIndex === this.images.length)? 0 : currentImageIndex].src;
    },
    validateAuthenticated() {
      if (this.$store.state.token !== '') {
        if (this.referrer_id != null)
          this.$router.push({ name: 'profile', params: { referred: this.referrer_id } });
        else if (!this.$store.state.user.isPro) {
          if (this.highlight !== '')
            this.$router.push({ name: 'subscription-plans', params: { highlight: this.highlight }});
          else
            this.$router.push('/subscription-plans');
        } else
          this.$router.push('/dashboard');
      }
    },
    getQueryParams() {
      if (this.$route.query.landingKey !== undefined)
        this.landingKey = this.$route.query.landingKey;
      if (this.$route.query.highlight !== undefined)
        this.highlight = this.$route.query.highlight;
      if (this.$route.query.discount !== undefined)
        this.discount = this.$route.query.discount;
    },

    validateEmail() {
      if (this.valid) {
        this.loadingRegister = true;
        AuthRepository.existingUsernameOrEmail(this.username, this.email).then((response) => {
          if (response.status < 400) {
            this.loadingRegister = false;
            let data = response.data;
            if (data === -1) {
              this.goNext();
              /*this.$router.push({
                name: 'basic-data',
                params: {
                  firstName: this.firstName,
                  lastName: this.lastName,
                  email: this.email,
                  username: this.username,
                  password: this.password,
                  referredFrom: this.referred,
                  plan: this.highlight,
                  landingKey: this.landingKey,
                  discount: this.discount,
                }
              });*/
            } else
              this.dialogExistingEmailOrUsername(data);
          }
        });
      } else
        alert(this.$t('alertMessage_Welcome'));
    },
    async createCollapsedAccount() {
      this.loadingRegister = true;
      // Get reCAPTCHA token
      const recaptchaToken = await getRecaptchaToken('register_collapsed');
      
      AuthRepository.existingUsernameOrEmail(this.username, this.email).then((response) => {
        if (response.status < 400) {
          let data = response.data;
          if (data === -1) {
            let user = {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              username: this.username,
              password: this.password,
              phoneNumber: 'NOT REGISTERED',
              referredFrom: this.referrer_id,
              langKey: this.$i18n.locale,
              channel: 'OTHER',
              withoutAuth: true,
              recaptchaToken: recaptchaToken,
            };
            AuthRepository.registerCollapsedUser(user, this.inviteCode).then((secondResponse) => {
              if (secondResponse.status < 400) {
                const postAfiliateCampaingId = this.$store.state.whitelabel.partner !== null ? process.env.VUE_APP_POSTAFFILIATE_WL_CAMPAIGN_ID:process.env.VUE_APP_POSTAFFILIATE_CAMPAIGN_ID;
                PostAfiliatesUtilites.registerTracking(this.referrer_id,postAfiliateCampaingId,this.email);
                window.sendinblue.identify(this.email, {
                  'NOMBRE': this.firstName,
                  'SURNAME' : this.lastName,
                  'USERNAME': this.username,
                  'PHONE': 'NOT REGISTERED',
                  'COUNTRY': 'NOT REGISTERED',
                  'PRO_ON' : '0',
                  'LANG' : this.$i18n.locale,
                  'CHANNEL' : 'OTHER',
                  'USAGE_STATE': 'PRE_REGISTERED',
                  'COMMERCIAL_STATE': 'NEVER_PRO',
                });
                window.fbq('track', 'SubmitApplication');
                window.fbq('trackCustom', 'VirtualPageView',
                    { url: (this.landingKey !== '')? `/pre-registration-by-desktop-${this.landingKey}` : '/pre-registration-by-desktop' });
                /*this.$router.push({
                name: 'subscription-plans-collapsed',
                params: {
                  userId: Number.parseInt(secondResponse.data.id),
                  highlight: this.highlight,
                  discount: Number.parseInt(this.discount)
                }});*/
                this.loadingRegister = false;
                this.$router.push({ name: 'confirmed-email', params: { email: this.email, password: this.password, referredFrom: this.from_referred, highlight:this.highlight, comeFrom: "Welcome"} });
                
              }
            });
          }
          else
            this.dialogExistingEmailOrUsername(data);
        }
      });
    },
    async createAccount() {
      if (this.valid) {
        this.loadingRegister = true;
        // Get reCAPTCHA token
        const recaptchaToken = await getRecaptchaToken('register_collapsed');
        
        AuthRepository.existingUsernameOrEmail(this.username, this.email).then((response) => {
          if (response.status < 400) {
            let data = response.data;
            if (data === -1) {
              const userData = {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                username: this.username,
                password: this.password,
                phoneNumber: 'NOT REGISTERED',
                country: this.country,
                typeOfTrader: this.traderType,
                previousExperience: this.traderExperience,
                referredFrom: this.referrer_id,
                langKey: this.$i18n.locale,
                channel: 'OTHER',
                recaptchaToken: recaptchaToken,
              };

              AuthRepository.registerCollapsedUser(userData, this.inviteCode).then((response) => {
                if (response.status < 400) {
                  const postAfiliateCampaingId = this.$store.state.whitelabel.partner !== null
                    ? process.env.VUE_APP_POSTAFFILIATE_WL_CAMPAIGN_ID
                    : process.env.VUE_APP_POSTAFFILIATE_CAMPAIGN_ID;

                  PostAfiliatesUtilites.registerTracking(this.referrer_id, postAfiliateCampaingId, this.email);
                  
                  window.sendinblue.identify(this.email, {
                    'NOMBRE': this.firstName,
                    'SURNAME': this.lastName,
                    'USERNAME': this.username,
                    'PHONE': 'NOT REGISTERED',
                    'COUNTRY': this.country,
                    'PRO_ON': '0',
                    'LANG': this.$i18n.locale,
                    'CHANNEL': 'OTHER',
                    'USAGE_STATE': 'PRE_REGISTERED',
                    'COMMERCIAL_STATE': 'NEVER_PRO',
                  });
                  
                  window.fbq('track', 'SubmitApplication');
                  window.fbq('trackCustom', 'VirtualPageView',
                    { url: (this.landingKey !== '') ? `/pre-registration-by-desktop-${this.landingKey}` : '/pre-registration-by-desktop' });

                  this.loadingRegister = false;
                  this.$router.push({ 
                    name: 'confirmed-email', 
                    params: { 
                      email: this.email, 
                      password: this.password, 
                      referredFrom: this.from_referred, 
                      highlight: this.highlight, 
                      comeFrom: "Welcome"
                    } 
                  });
                }
              });
            } else {
              this.dialogExistingEmailOrUsername(data);
            }
          }
          this.loadingRegister = false;
        });
      }
    },
    dialogExistingEmailOrUsername(data) {
      if (data === 1) {
        this.existingEmail = true;
        this.existingUsername = false;
      } else {
        this.existingEmail = false;
        this.existingUsername = true;
      }
      this.existingUsernameOrEmail = true;
    },
  },
}

</script>

<style lang="scss" >
@import "src/global.scss";

.language-selector-container {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 100;
}

.white-text :deep(.language-selector-trigger) {
  color: white !important;
}

.white-text :deep(.language-name),
.white-text :deep(.dropdown-icon) {
  color: white !important;
}

.login-container {
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

.signup-image {
  padding: 0;
  background-color: #111111;
  background-image: url("https://hub.swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png");
  background-repeat: no-repeat;
  background-size: contain, cover;
  background-position: right;
}

.registerForm{
  .theme--dark.v-input input{
    color: #ffffff !important;
  }
}
</style>




